var _line, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartE(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 67,
    viewBox: "0 0 64 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.548825,
    y1: 41.3574,
    x2: 63.4512,
    y2: 41.3574,
    stroke: "#828282",
    strokeWidth: 1.09765,
    strokeLinecap: "round",
    strokeDasharray: "2.2 2.2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.40234 40.8803C9.07266 30.513 10.6814 8.81076 11.7539 4.9403C12.4243 2.40607 14.4352 -1.14185 17.1165 4.9403C17.3399 5.86183 17.7868 7.98134 17.7868 9.08719C18.0103 23.8318 18.9934 53.5975 21.1384 54.7033C22.0322 55.3945 24.2219 54.9798 25.8307 47.7918C26.2776 46.8703 27.4394 45.9948 28.512 49.8653C28.9588 52.3995 30.2548 58.9885 31.8636 65.0706C32.7573 65.9922 34.813 66.3147 35.8855 60.2326C36.7792 53.0906 38.969 38.5303 40.5777 37.4245C41.6949 36.0422 44.5996 35.2128 47.2809 42.9537C48.3981 44.1057 51.4369 45.3037 54.6545 40.8803",
    stroke: "#66FCF1",
    strokeWidth: 2.43216,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartE);
export default __webpack_public_path__ + "static/media/chartE.3f8249cb314b913f832c4ddceac500aa.svg";
export { ForwardRef as ReactComponent };